import { IFormField, IFormSection } from "../web-form.objects"
import _ from "lodash";

export class NumberInputOptions {
    isInteger: boolean = false;
    minValue: number = undefined;
    maxValue: number = undefined;
    constructor(isInteger: boolean = false, minValue: number = undefined, maxValue: number = undefined) {
        this.isInteger = isInteger;
        this.minValue = minValue;
        this.maxValue = maxValue;
    }
}

export class NumberInputField implements IFormField {
    fieldId: string; 
    displayName: string; 
    isRequired: boolean;
    propertyName: string; 
    defaultVal: any; 
    formSection: IFormSection;
    forObjProperty: boolean = true;
    shouldTriggerUpdate: boolean = false;

    options: NumberInputOptions;

    constructor(propertyName: string, defaultVal: any, fieldId: string, displayName: string, isRequired: boolean, options: NumberInputOptions = new NumberInputOptions()) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;
        this.options = options;
        
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection;

        this.initializeSectionUpdateTrigger();
    }

    private initializeSectionUpdateTrigger() {
        $(`#${this.fieldId}`).on("keyup change", () => {
            this.triggerSectionUpdate();
        });
    }

    private getInput(): string {
        let input = (<string>$(`#${this.fieldId}`).val()).trim();
        return input;
    }

    private setInput(data: any): void {
        $(`#${this.fieldId}`).val(data);
    }

    private getParsedInput(): number {
        let input = this.getInput();
        if (this.options.isInteger) {
            let val = parseInt(input);
            if (val) {
                return val;
            }
        }
        else {
            let val = parseFloat(input);
            if (val) {
                return val;
            }
        }

        return this.defaultVal;
    }

    getValue(): any {
        let val = this.defaultVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getParsedInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            this.setInput(formVal);
        }
    }

    checkValid(): boolean {
        let val = this.getParsedInput();

        // min/max
        if (this.options.minValue != undefined) {
            if (val < this.options.minValue) {
                return false;
            }
        }
        if (this.options.maxValue != undefined) {
            if (val > this.options.maxValue) {
                return false;
            }
        }      

        if (this.isRequired) {
            let input = this.getInput();
            // empty
            if (!input) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.getParsedInput();
        if (val != this.defaultVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid").removeClass("is-invalid");
    }

    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }
}

